export const getChecklistRowsData = (checklists) => {
  var NotStarted = 0;
  var complete = 0;

  checklists.forEach((checklist) => {
    complete += checklist.hasOwnProperty("rows")
      ? checklist.rows.filter(
          (row) =>
            (row.hasOwnProperty("value") &&
              row.value.length > 0 &&
              row["Row Type"] !== "Header" &&
              row["Row Type"] !== "Information Row") ||
            (row.hasOwnProperty("value") &&
              row.value.hasOwnProperty("url") &&
              row.value.url.length > 0 &&
              row["Row Type"] !== "Header" &&
              row["Row Type"] !== "Information Row"),
        ).length
      : 0;
    NotStarted += checklist.hasOwnProperty("rows")
      ? checklist.rows.filter(
          (row) => row.hasOwnProperty("value") && row.value.length === 0,
        ).length
      : 0;
  });

  return [
    {
      order: 1,
      name: `Not Started (${NotStarted})`,
      value: NotStarted,
      color: "#7e57c2",
    },
    {
      order: 3,
      name: `Complete (${complete})`,
      value: complete,
      color: "#50C878",
    },
  ];
};
